import { ViewModel,View } from "binder"
import { ServerConnection } from "src/server/serverConnection";
import { IGateway, IPaymentInfoProvider } from "../IGateway";
import  { CashGatewayView } from "./cashGateway-view"
import { DistrictSelectorViewModel } from "src/EnterpriseAdministration/districtManipulation/districtSelector";

export class CashGatewayViewModel extends ViewModel implements IGateway{
    constructor(parentViewModel: ViewModel) {
        super(parentViewModel);
    }
    get title(): string {
        return 'نقد';
    }

    GetDefaultView(): View <ViewModel> {
        return new CashGatewayView();
    }

    public getTypeId(): string {
        return "VM-FCCDAC4D-B521-4C43-9A8C-8CE8B14EC036"
    }

    public set district(v: DistrictSelectorViewModel) { this._district = v; } public get district(): DistrictSelectorViewModel { return this._district;} private _district: DistrictSelectorViewModel;
    
    initialLoad(): void {
        this.district = new DistrictSelectorViewModel(this);
    }

    async save(dataProvider: IPaymentInfoProvider): Promise<any> {
        let paymentInfo = dataProvider.getBasePaymentInfoDto();
        return await ServerConnection.callServer('Complex/PaymentProcessServices/CreateCashPayment',{
            PayableInfo:dataProvider.getBasePaymentInfoDto(),
            DistrictId:this.district.selectedItem.id
        });
    }

    validate(): string[] {
        if(this.district.selectedItem==null){
            return ['صندوق مورد نظر انتخاب نشده است.'] 
        }
        return [];
    }
    
}
